import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import NavBar from '../components/NavBar'
import Payee from '../components/payees/Payee'
import ViewPayees from '../components/payees/ViewPayees'
import { useParams } from 'react-router-dom';

const PayeesView = () => {
    const payeeId = useParams();
    return (
        <div>
        <Header />
        <NavBar />
        <Payee payeeIdToEdit={payeeId}/>
        <ViewPayees limit={6}/>
        <Footer />
            
        </div>
    )
}

export default PayeesView
